import { gsap } from "gsap";

export default function () {
    const aboutTimeline = gsap.timeline()
    if (!document.querySelector('[data-block="about"]'))
        return aboutTimeline

    const aboutHeading = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="about"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    aboutHeading.from('[data-block="about-heading"] > h2', { opacity: 0, y: 40 })
        .from('[data-block="about-heading"] > span', { opacity: 0, y: -40 }, '<')

    gsap.from('[data-block="about-partner"]', {
        opacity: 0,
        scale: 0,
        stagger: .4,
        scrollTrigger: {
            trigger: '[data-block="about-partner"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    gsap.from('[data-block="about-logo"]', {
        opacity: 0,
        scale: 0,
        scrollTrigger: {
            trigger: '[data-block="about-logo"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    gsap.from('[data-block="about-grid"] > h2', {
        opacity: 0,
        y: -40,
        scrollTrigger: {
            trigger: '[data-block="about-grid"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    const aboutContent = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="about-content"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    aboutContent.from('[data-block="about-content"] > figure img', { xPercent: -100, yPercent: -100, ease: "cubic", duration: 1.6 })
        .from('[data-block="about-content"] > h3', { opacity: 0, y: 40 }, '>')
        .from('[data-block="about-content"] > p', { opacity: 0, y: 40 }, '-=.24')
        .from('[data-block="about-content-show-more"]', { opacity: 0, x: 40 }, '-=.24')

    const aboutMoreContent = gsap.timeline({
        paused: true,
        onStart: () => {
            const el = document.querySelector('[data-block="about-content"] > h3'),
                elRect = el.getBoundingClientRect(),
                scrollTarget = window.innerWidth < 768 ? '[data-block="about-grid"]'
                    : elRect.top + window.scrollY - (window.innerHeight / 2)

            window.lenis.scrollTo(scrollTarget, {
                lock: true,
                onComplete: () => window.lenis.stop()
            })
        },
        onReverseComplete: () => window.lenis.start()
    })

    aboutMoreContent.fromTo('[data-block="about-grid"] > h2', { xPercent: 0, opacity: 1 }, { xPercent: -50, opacity: 0, immediateRender: false })
        .fromTo('[data-block="about-content-cover"]', { opacity: 0, pointerEvents: 'none' }, { opacity: 1, pointerEvents: 'auto' }, '<')
        .fromTo('[data-block="about-content"]', { xPercent: 0, x: 0 }, { xPercent: -112, x: '-120px' }, '-<=.24')
        .fromTo('[data-block="about-content-show-more"]', { opacity: 1, pointerEvents: 'auto' }, { opacity: 0, pointerEvents: 'none', immediateRender: false }, '<')
        .fromTo('[data-block="about-content-more-content"]', { opacity: 0, y: 40, pointerEvents: 'none' }, { opacity: 1, y: 0, pointerEvents: 'auto' }, '-=.24')

    document.querySelector('[data-block="about-content-show-more"]')
        .addEventListener('click', () => aboutMoreContent.play())

    document.querySelector('[data-block="about-content-hide-more"]')
        .addEventListener('click', () => aboutMoreContent.reverse())

    document.querySelector('[data-block="about-content-cover"]')
        .addEventListener('click', () => aboutMoreContent.reverse())

    const aboutCaseStudy = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="about-case-study"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    aboutCaseStudy.from('[data-block="about-case-study"] > figure img', { xPercent: 100, yPercent: 100, ease: "cubic", duration: 1.6 })
        .from('[data-block="about-case-study"] > aside span', { opacity: 0, y: 40 }, '>')
        .from('[data-block="about-case-study"] > aside small', { opacity: 0, y: 40 }, '-=.24')

    // TODO: přidat do timeliny ?!

    document.querySelector('[data-block="about-content-show-more"]').addEventListener("click", () => {

    })

    return aboutTimeline
}